import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, AlertCircle } from 'lucide-react';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12 text-center">
      <div className="w-full max-w-md">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-600 ring-1 ring-inset ring-primary-100 dark:bg-primary-900/30 dark:text-primary-400 dark:ring-primary-800/40">
          <AlertCircle className="h-6 w-6" />
        </div>
        <h1 className="mt-5 text-3xl font-semibold tracking-tight text-gray-900 dark:text-gray-50 sm:text-4xl">
          {t('ra.page.not_found')}
        </h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {t('ra.message.not_found')}
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="btn btn-primary"
          >
            <Home className="h-4 w-4" aria-hidden="true" />
            {t('ra.action.home')}
          </Link>
        </div>
      </div>
      <div className="mt-12 text-center">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {t('If you believe this is an error, please contact support.')}
        </p>
      </div>
    </div>
  );
};

export default NotFound;